import { createAsyncThunk } from '@reduxjs/toolkit'

import { ThunkApi } from '../index.d'
import {
  BeforeClientAddEditParams,
  BeforeLoanAddParams,
  BeforeLoanAddServerData,
  BeforeLoanDisburseParams,
  BeforeLoanDisburseServerData,
  BeforeEntryAddEditParams,
  BeforeEntryAddEditServerData,
  BeforeConvAddEditParams,
  BeforeConvAddEditServerData,
  BeforeLoanCoverParams,
  BeforeLoanCoverServerData,
  BeforeLoanVisaParams,
  BeforeLoanVisaServerData,
  BeforeCollateralAddEditParams,
  BeforeCollateralAddEditServerData,
  BeforeUccPayParams,
  BeforeUccPayServerData,
  EventsViewParams,
  EventsViewServerData,
} from '@lk/api'

export const beforeClientAddEdit = createAsyncThunk<void, BeforeClientAddEditParams, ThunkApi>(
  '[EVENT] BEFORE_CLIENT_ADD_EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeClientAddEdit(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue(result.error)
    }
  },
)

export const beforeLoanAdd = createAsyncThunk<BeforeLoanAddServerData, BeforeLoanAddParams, ThunkApi>(
  '[EVENT] BEFORE_LOAN_ADD',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeLoanAdd(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before loan add event')
    }
  },
)

export const beforeLoanDisburse = createAsyncThunk<BeforeLoanDisburseServerData, BeforeLoanDisburseParams, ThunkApi>(
  '[EVENT] BEFORE_LOAN_DISBURSE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeLoanDisburse(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before loan disburse event')
    }
  },
)

export const beforeEntryAddEdit = createAsyncThunk<BeforeEntryAddEditServerData, BeforeEntryAddEditParams, ThunkApi>(
  '[EVENT] BEFORE_ENTRY_ADD_EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeEntryAddEdit(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before entry add/edit event')
    }
  },
)

export const beforeConvAddEdit = createAsyncThunk<BeforeConvAddEditServerData, BeforeConvAddEditParams, ThunkApi>(
  '[EVENT] BEFORE_CONV_ADD_EDIT',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeConvAddEdit(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before conv add/edit event')
    }
  },
)

export const beforeLoanCover = createAsyncThunk<BeforeLoanCoverServerData, BeforeLoanCoverParams, ThunkApi>(
  '[EVENT] BEFORE_LOAN_COVER',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeLoanCover(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before loan cover event')
    }
  },
)

export const beforeLoanVisa = createAsyncThunk<BeforeLoanVisaServerData, BeforeLoanVisaParams, ThunkApi>(
  '[EVENT] BEFORE_LOAN_VISA',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeLoanVisa(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before loan visa event')
    }
  },
)

export const beforeCollateralAddEdit = createAsyncThunk<
  BeforeCollateralAddEditServerData,
  BeforeCollateralAddEditParams,
  ThunkApi
>('[EVENT] BEFORE_COLLATERAL_ADD_EDIT', async (params, { extra, rejectWithValue }) => {
  const result = await extra.api.event.beforeCollateralAddEdit(params)

  if (result.success) {
    return result.data
  } else {
    return rejectWithValue('Failed to raise before collateral add/edit event')
  }
})

export const beforeUccPay = createAsyncThunk<BeforeUccPayServerData, BeforeUccPayParams, ThunkApi>(
  '[EVENT] BEFORE_UCC_PAY',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.beforeUccPay(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue('Failed to raise before ucc pay event')
    }
  },
)

export const view = createAsyncThunk<EventsViewServerData, EventsViewParams, ThunkApi>(
  '[EVENT] VIEW',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.event.view(params)

    if (result.success) {
      return result.data
    } else {
      return rejectWithValue(result.error.message)
    }
  },
)
